import { Box, IconButton, Stack, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';
import { radius } from '@karehero/llama/theme/radius';

// One message in the Keni triage transcript. Keni speaks on the left on a paper
// surface; the user's replies sit right on coral. Keni's messages get a replay
// button so they can be heard out loud again. Rendered per message.
export type ChatBubbleProps = {
  from: 'keni' | 'user';
  text: string;
  /** Replay this message out loud. Only wired for Keni's messages. */
  onReplay?: () => void;
};

const ChatBubble = ({ from, text, onReplay }: ChatBubbleProps) => {
  const isKeni = from === 'keni';

  const bubble = (
    <Box
      sx={{
        maxWidth: '100%',
        px: 2,
        py: 1.25,
        bgcolor: isKeni ? 'background.paper' : 'custom.coral.600',
        border: isKeni ? 1 : 0,
        borderColor: 'custom.neutral.200',
        borderRadius: `${radius.lg}px`,
        borderBottomLeftRadius: isKeni ? '4px' : '16px',
        borderBottomRightRadius: isKeni ? '16px' : '4px',
      }}
    >
      <Typography
        sx={{ color: isKeni ? 'text.primary' : 'custom.neutral.50' }}
        variant='body2'
      >
        {text}
      </Typography>
    </Box>
  );

  if (isKeni && onReplay) {
    return (
      <Stack
        sx={{
          alignItems: 'flex-end',
          alignSelf: 'flex-start',
          maxWidth: '90%',
        }}
        direction='row'
        spacing={0.5}
      >
        {bubble}
        <IconButton
          size='small'
          aria-label='Replay out loud'
          onClick={onReplay}
        >
          <Icon icon={'volume-high' as never} fontSize={13} />
        </IconButton>
      </Stack>
    );
  }

  return (
    <Box
      sx={{ alignSelf: isKeni ? 'flex-start' : 'flex-end', maxWidth: '82%' }}
    >
      {bubble}
    </Box>
  );
};

ChatBubble.displayName = 'ChatBubble';
export default ChatBubble;
